import fetch from 'utils/fetch';

export function fetchForDropdown(url, callBack) {
  fetch(url)
    .then(res => res.json())
    .then(json => {
      callBack(json);
    });
}

export const fetchForContent = (url, callBack) => {
  fetch(url)
    .then(res => res.json())
    .then(json => {
      callBack(json);
    });
};



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/imports/api/index.js